import { render, staticRenderFns } from "./footer-nav.vue?vue&type=template&id=3fe5202b&scoped=true"
import script from "./footer-nav.vue?vue&type=script&lang=js"
export * from "./footer-nav.vue?vue&type=script&lang=js"
import style0 from "./footer-nav.vue?vue&type=style&index=0&id=3fe5202b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe5202b",
  null
  
)

export default component.exports